module.exports = __webpack_public_path__ + "img/360.e8cc37b1.png";